<div  id="containerFoto" class="container">
    <img class="background-foto" src="../../../assets/images/Itinerari-esperienze/04_Aspromonte/04_1_SerraSanBruno-Canolo/04_1_Mongiana.jpg">
<div class="content">
    <h1>Aspromonte</h1>
    <h3>Sulle strade della Ciclovia dei Parchi</h3>
</div>
</div>
<br>
<div class="breadcrumb">
    <p><a>Scopri la Calabria</a> > <a>Parchi e Riserve</a> > <a>Parco Nazionale dell’Aspromonte</a> > <a class="active">Sulle strade della Ciclovia dei Parchi</a></p>
</div>
<br>
<div id="fixed-element" [ngClass]="[isFixed ? 'fixed': 'notFixed']">
    <app-sidenav></app-sidenav>
</div>
<div class="row schedaItinerario">
    <h2>Serra San Bruno-Mammola-Canolo</h2>
</div>
<br>
<div class="row schedaItinerario">
    <div class="col-xl-6 col-12">
        <img class="itinerario-foto" src="../../../assets/images/Itinerari-esperienze/04_Aspromonte/04_1_SerraSanBruno-Canolo/04_1_Mongiana.jpg">
    </div>
    <div class="col-xl-4 ml-4 col-12">
        <div id="map" class="mapInfo"></div>
    </div>
</div>
<br>
<div class="row schedaItinerario">
    <div class="col-xl-6 col-12">
        <p class="testoItinerario">
            L’itinerario si snoda tra la Riserva naturale regionale delle Serre e il Parco nazionale dell’Aspromonte. 
            Si tratta di un viaggio molto coinvolgente sia per i paesaggi naturali che si attraversa, soprattutto faggete secolari, 
            pinete fitte e boschi misti, ma anche per i contenuti di spiritualità e d’arte che lo connotano: si incontrano luoghi di culto di straordinaria 
            importanza e di incomparabile bellezza, a partire dalla Certosa di Serra San Bruno, fino al Complesso monastico di Santa Barbara a Mammola, 
            oggi museo d’arte contemporanea, il MUSABA ideato e realizzato da Nik Spatari, recentemente scomparso, e Hiske Maas, che si estende intorno ai 
            resti dell’antico complesso monastico certosino. Il Museo propone una sorta di sinossi delle arti del Mediterraneo, dalle incisioni rupestri della 
            Valle Camonica fino a Picasso. 
            <br>
            <br>
            Oltre a ciò, non mancano gli elementi di attrazione che riguardano la storia e le tradizioni di questo territorio, 
            per millenni attraversato da genti e popoli diversi, punto di passaggio strategico tra Jonio e Tirreno. A Mammola, 
            ad esempio, non si può mancare di gustare il pregiatissimo pesce stocco.
            <br>
            <br>
            L’approdo a Canolo vecchia è di quelli da togliere il fiato: «Spinto in un nido di rocce appuntite subito dopo il vasto precipizio che 
            si chiude attorno al Passo del Mercante», come lo descrisse il pittore e scrittore inglese Edward Lear nel suo Journals of a landscape painter 
            in southern Calabria pubblicato nel 1852, Canolo “vecchia” è un borgo molto suggestivo situato al centro di due grandi canyon con il 
            Torrente Pachina che scorre fra il paese e il Massiccio di Monte Mutolo. Si parla di autentiche torri rocciose dai colori cangianti da cui 
            si domina la locride, paradiso degli arrampicatori, tra i Geositi del Parco Nazionale dell’Aspromonte di maggior pregio geologico e naturalistico. 
            Fondato in epoca bizantina, a causa dell’alluvione del 1951 il paese perse i suoi abitanti che dovettero trasferirsi nel borgo di Canolo Nuova (900 m slm) 
            che dista circa 9 Km.             
        </p>
    </div>
    <div class="col-xl-4 ml-4 col-12">
        <div class="row">
            <div class="col">
                <h5>Percorso:</h5>
            </div>
            <div class="col right">
                <h5> in bici</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Difficoltà:</h5>
            </div>
            <div class="col right">
                <h5>difficile</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Lunghezza:</h5>
            </div>
            <div class="col right">
                <h5>67,7 Km</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Giorni:</h5>
            </div>
            <div class="col right">
                <h5>2</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Salita:</h5>
            </div>
            <div class="col right">
                <h5>1560 m</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Discesa:</h5>
            </div>
            <div class="col right">
                <h5>1490 m</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Luogo di Partenza:</h5>
            </div>
            <div class="col right">
                <h5>Serra San Bruno</h5>
            </div>
        </div>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <h5>Luogo di arrivo:</h5>
            </div>
            <div class="col right">
                <h5>Canolo</h5>
            </div>
        </div>
        <div class="divider"></div>
    </div>
</div>
<br>
<br>
<div class="divider2">

</div>
<br>
<br>
<div class="row bannerPollino">
    <div class="col-10 col-xl-8">
        <h1 class="banner-header">ESPERIENZE E ITINERARI</h1>
        <br>
        <p>Scegli fra le tante idee di viaggio e proposte di itinerari tematici<br />per conoscere il Parco nazionale dell’Aspromonte.</p>
    </div>
    <div class="col-2 col-xl-1">
        <img style="width: 65%;" src="../../../assets/images/logo-parco-top2.png">
    </div>
</div>
<br>
<br>
<div class="home-card">
    <div class="row">
        <div class="col-12 col-xl-3 one" id="one">
            <div class="card one">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Sulle strade<br />della Ciclovia<br />dei Parchi</h1>
                        <a (click)="goToCiclovia()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-xl-3 two" id="two">
            <div class="card two">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Gerace</h1>
                        <a (click)="goToGerace()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-xl-3 three" id="three">
            <div class="card three">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Area grecanica</h1>
                        <a (click)="goToAreaGrecanica()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<br>
<br>
<div class="divider2">
    
</div>
<br>
<br>
<app-mappe-tematiche></app-mappe-tematiche>
<br>
<br>

<div class="noMobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi <br />
                    iscriviti alla nostra newsletter ></h2>
            </div>
            <div class="col">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />
                    novità su proposte, esperienze, eventi e qualche curiosità.</p>  
            </div>
        </div>
        <div class="row">
            <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
        </div>
    </div>
</div>


<div class="mobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi<br />iscriviti alla nostra newsletter</h2>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-12">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <br>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />novità su proposte, esperienze, eventi e qualche curiosità.</p>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
            </div>
        </div>
    </div>
</div>
